import type { FC } from 'react';
import React from 'react';

import styles from './Arrow.module.scss';

interface ArrowProps {
  className: string;
}

export const Arrow: FC<ArrowProps> = ({ className }) => {
  return (
    <div className={className}>
      <div className={styles.arrowIcon}></div>
    </div>
  );
};
